import API from '../../../services/apiService.js'

var api= new API();


export default {

  async getRequests({commit}, params){
    var data=null;
    try{
      let query= `?DateBeg=${params.dateBeg}&DateEnd=${params.dateEnd}`
      data =  api.Get("RequestService/Request/FilteredDateRequest"+query);
      commit('loadRequests', await data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },


  async getBySignalR({commit}, id){
    var data=null;
    try{
      var params="?requestId="+id
      data =  await api.Get("RequestService/Request/RequestById"+params);
      commit('loadById', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //получить список откликов на заявку
  async getRequestAnswers({commit}, id){
    var data=null;
    try{
      var params="?requestId="+id
      data =  await api.Get("RequestService/Request/Answers"+params);
      commit('loadRequestAnswers', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  async getChatMessages({commit}, RequestAnswerId){
    let data=null;
    try{
      data =  api.Get(`Chat/RequestAnswer?RequestAnswerId=${RequestAnswerId}`);
      commit('loadChatMessage', await data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },


}
